import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistSaleReports = (filters, search, page, pageSize = 10, sort, artistId, cancelToken = null) => {
  return axios.get(URL_PREFIX + '/artist-sale-reports/', {
    params: {
      artist: artistId,
      ordering: sort,
      search: search,
      fromDateFilter: filters.start?.value,
      toDateFilter: filters.end?.value,
      artTypeFilter: filters.artTypeFilter?.value,
      paymentFilter: filters.paymentFilter?.value,
      fulfillmentFilter: filters.fulfillmentFilter?.value,
      page: page,
      page_size: pageSize
    },
    cancelToken: cancelToken?.token
  })
}

export const getArtistSaleReport = (id) => {
  return axios.get(URL_PREFIX + '/artist-sale-reports/' + id + '/')
}

export const getArtistSaleReportsAdmin = (page, pageSize = 10) => {
  return axios.get(URL_PREFIX + '/artist-sale-reports-admin/', {
    params: {
      page: page,
      page_size: pageSize
    }
  })
}

export const postArtistSaleReports = (params) => {
  return axios.post(URL_PREFIX + '/artist-sale-reports/', params)
}

export const patchArtistSaleReports = (id, params) => {
  return axios.patch(URL_PREFIX + '/artist-sale-reports/' + id + '/', params)
}

export const deleteArtistSaleReports = (id) => {
  return axios.delete(URL_PREFIX + '/artist-sale-reports/' + id + '/')
}

export const retrieveUPSTracking = (ups_num) => {
  // var UPS_URL_PREFIX = 'https://onlinetools.ups.com/track/v1/details/'
  // var UPS_URL_POSTFIX = '?locale=en_US'
  // return "https://onlinetools.ups.com/track/v1/details/" + ups_num + "/?locale=en_US";
  // return axios.get("https://onlinetools.ups.com/track/v1/details/" + ups_num + "/?locale=en_US",{
  //   method: 'GET',
  //   // url: UPS_URL_PREFIX + ups_num + UPS_URL_POSTFIX,
  //   headers: {
  //     transId: 12345,
  //     transactionSrc: "RevArt",
  //     Username: "revart21",
  //     AccessLicenseNumber: "0DB12571043EB016",
  //     ContentType: "application/json",
  //     Accept: "application/json",
  //     crossdomain: true
  //   }
  // });
  return axios.get('https://revart.co/track/ups/' + ups_num)
}
